import type { AppThunk } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import handleRequestError from 'managers/handleRequestError';
import { DataServiceFlightDefinitionRules, FlightDefinitionRulesModel } from 'common/dataService';
import { setUpdating, setUpdatingKey } from '../slice';

function addFlightDefinitionRules(requestParameters: FlightDefinitionRulesModel): AppThunk {
  return async function addFlightDefinitionRulesThunk(dispatch, getState) {
    try {
      const { updating } = getState().flightDefinitionRules.definitionRules;

      if (updating === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setUpdatingKey('create'));
      dispatch(setUpdating(FetchingStatus.InProgress));

      await DataServiceFlightDefinitionRules.postFlightDefinitionRules(requestParameters);

      dispatch(setUpdating(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on saving flight definition rules!', setUpdating));
    }
  };
}

export default addFlightDefinitionRules;
